import { render } from "./AtendimentoVisaoToggle.vue?vue&type=template&id=741ce42d&scoped=true"
import script from "./AtendimentoVisaoToggle.vue?vue&type=script&lang=js"
export * from "./AtendimentoVisaoToggle.vue?vue&type=script&lang=js"

import "./AtendimentoVisaoToggle.vue?vue&type=style&index=0&id=741ce42d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741ce42d"]])

export default __exports__